import React, { useEffect, useState } from 'react'
import TextInput from '../../form/TextInput';
import { MenuItem } from '@mui/material';
import Button1 from '../../form/Button1';
import addTax from '../../../controllers/Tax/addTax';
import { enqueueSnackbar } from 'notistack';
import updateTax from '../../../controllers/Tax/updateTax';


export default function TaxForm({data: defData,close,callback}) {
    const [data,setData] = useState(defData || {
        "taxName": '',
        "taxAmount": 0,
        "taxMethod": "" //Fixed, Percentage
    })
    const [loadings,setLoadings] = useState({submit: false})

    useEffect(() => {
        if(defData)
            setData(defData);
    },[defData])
    
    async function handleSubmit(ev) {
        ev?.preventDefault();
        const {_id,updated_at,created_at,status,...modData} = {...data,
            taxAmount: Number(data?.taxAmount)
        };
        setLoadings({...loadings,submit: true});
        let res = {return: 0, msg: '0XTAXFORM'};
        if(defData)
            res = await updateTax(_id,modData)
        else res = await addTax(modData);
        setLoadings({...loadings,submit: false});
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
            callback && callback()
            close && close();
        } else enqueueSnackbar(res.msg,{variant: 'error'})

    }
    
  return (
    <form onSubmit={handleSubmit} className='flex flex-col gap-4 p-4'>
      <TextInput label='Name' value={data?.taxName} onChange={(ev) => setData({...data,taxName: ev.target.value})} />
      <TextInput label='Amount' type='number' value={data?.taxAmount} onChange={(ev) => setData({...data,taxAmount: ev.target.value})} />
      <TextInput select label='Method' value={data?.taxMethod} onChange={(ev) => setData({...data,taxMethod: ev.target.value})} >
        <MenuItem value='Percentage'>Percentage</MenuItem>
        <MenuItem value='Fixed'>Fixed</MenuItem>
      </TextInput>
      <div className='flex gap-4 items-center'>
        <div>
            {close ? 
                <Button1 variant='outlined' type='button' onCLick={() => close()}>Cancel</Button1>
            :null}
        </div>
        <Button1 loading={loadings?.submit} type='submit'>{defData ? 'Update' : `Add`}</Button1>
      </div>
    </form>
  )
}
